import { render, staticRenderFns } from "./CandidateJobAlerts.vue?vue&type=template&id=503b44ac&"
import script from "./CandidateJobAlerts.vue?vue&type=script&lang=js&"
export * from "./CandidateJobAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports